// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';

/** 此处后端没有提供注释 PUT /api/visit7 */
export async function visit7ControllerUpdate(
	body: API.Visit7UpdateRequest,
	options?: { [key: string]: any }
) {
	return request<boolean>('/api/visit7', {
		method: 'PUT',
		headers: {
			'Content-Type': 'application/json',
		},
		data: body,
		...(options || {}),
	});
}

/** 此处后端没有提供注释 GET /api/visit7/${param0} */
export async function visit7ControllerGet(
	// 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
	params: API.Visit7ControllerGetParams,
	options?: { [key: string]: any }
) {
	const { hubId: param0, ...queryParams } = params;
	return request<API.Visit7ViewResponse>(`/api/visit7/${param0}`, {
		method: 'GET',
		params: { ...queryParams },
		...(options || {}),
	});
}

/** 此处后端没有提供注释 POST /api/visit7/${param0} */
export async function visit7ControllerCreate(
	// 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
	params: API.Visit7ControllerCreateParams,
	body: API.Visit7CreateRequest,
	options?: { [key: string]: any }
) {
	const { hubId: param0, ...queryParams } = params;
	return request<boolean>(`/api/visit7/${param0}`, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
		},
		params: { ...queryParams },
		data: body,
		...(options || {}),
	});
}
